import moment from "moment";

export class SubTaskResult {
    public id: number;
    public creationDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public isDone: boolean;
    public ticketId: number;
    public title: string;
    public assignedEmployeeId: number | null;
    public assignedEmployeeFullName: string = '';
    public assignedEmployeePersonalPictureFileName: string = '';
    public isDeleted: boolean = false;

    // front-end
    public oldTitle: string;
    public isEditMode: boolean;

    constructor() {
        this.id = 0;
        this.ticketId = 0;
        this.isDone = false;
        this.assignedEmployeeId = null;
        this.title = '';
        this.oldTitle = '';
        this.isEditMode = false;
    }
}
